import Vue from 'vue';
import VueI18n from 'vue-i18n';
import messages from '@/locales';
import initLang from "@/utils/lang";

Vue.use(VueI18n);

const i18n = new VueI18n({
  locale: initLang,
  fallbackLocale: initLang,
  silentTranslationWarn: true,
  messages,
});

try {
  window.document.querySelector('html').setAttribute('lang', initLang);
} catch (e) {
  console.error('e = ', e);
}

// Hot updates
(function updateModules() {
  if (module.hot) {
    module.hot.accept('./locales', () => {
      for (let [key, message] of Object.entries(require('./locales').default)) {
        i18n.setLocaleMessage(key, message);
      }
    });
  }
})();

export default i18n;
